import { ResolveExpression as ResolveExpressionRaw, } from '@companion-app/expressions';
import { SplitVariableId, VARIABLE_UNKNOWN_VALUE } from './Variables.js';
export { ParseExpression, BANNED_PROPS, BuiltinFunctionNames } from '@companion-app/expressions';
export function ResolveExpression(node, options) {
    return ResolveExpressionRaw(node, {
        maxCallDepth: undefined,
        maxOperations: undefined,
        ...options,
        getVariableValue: (variableIdOrLabel, nameOrUndefined) => {
            if (nameOrUndefined !== undefined) {
                return options.getVariableValue({
                    variableId: `${variableIdOrLabel}:${nameOrUndefined}`,
                    label: variableIdOrLabel,
                    name: nameOrUndefined,
                });
            }
            else {
                const [label, name] = SplitVariableId(variableIdOrLabel);
                return options.getVariableValue({ variableId: variableIdOrLabel, label, name });
            }
        },
        // Defaults
        unknownVariableValue: VARIABLE_UNKNOWN_VALUE,
        processTemplateEscapes: false,
        stringConcatenation: false,
    });
}
//# sourceMappingURL=Expressions.js.map